import React, { useEffect, useState } from 'react';
import { MdDarkMode, MdLightMode, MdFormatSize } from 'react-icons/md';
import { useLanguage } from '../i18n';

// Per-person display settings kept in this browser: dark mode and larger text.
// Dark mode inverts the page colours (photos, charts' hues and videos are kept
// natural); larger text zooms the whole app in two steps.
const KEY = 'fms_display_prefs';
const ZOOM = [1, 1.12, 1.25];

function read() {
    try { return { dark: false, text: 0, ...(JSON.parse(localStorage.getItem(KEY)) || {}) }; } catch { return { dark: false, text: 0 }; }
}

export function applyDisplayPrefs(prefs = read()) {
    const root = document.documentElement;
    root.classList.toggle('fms-dark', !!prefs.dark);
    document.body.style.zoom = ZOOM[prefs.text] && ZOOM[prefs.text] !== 1 ? String(ZOOM[prefs.text]) : '';
}

export default function DisplayPrefs({ compact = false }) {
    const { t } = useLanguage();
    const [prefs, setPrefs] = useState(read);

    useEffect(() => {
        applyDisplayPrefs(prefs);
        try { localStorage.setItem(KEY, JSON.stringify(prefs)); } catch { /* private mode */ }
    }, [prefs]);

    const button = { border: '1px solid #e2e8f0', background: 'transparent', borderRadius: 8, width: compact ? 32 : 36, height: compact ? 32 : 36, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#475569', cursor: 'pointer' };

    return (
        <span style={{ display: 'inline-flex', gap: 6 }}>
            <button type="button" style={button} title={prefs.dark ? t('prefs.darkOff') : t('prefs.darkOn')} aria-label={prefs.dark ? t('prefs.darkOff') : t('prefs.darkOn')}
                onClick={() => setPrefs(p => ({ ...p, dark: !p.dark }))}>
                {prefs.dark ? <MdLightMode size={18} /> : <MdDarkMode size={18} />}
            </button>
            <button type="button" style={button} title={t('prefs.textSize')} aria-label={t('prefs.textSize')}
                onClick={() => setPrefs(p => ({ ...p, text: (p.text + 1) % ZOOM.length }))}>
                <MdFormatSize size={18} />
                {prefs.text > 0 && <sup style={{ fontSize: 9, marginLeft: 1 }}>{'+'.repeat(prefs.text)}</sup>}
            </button>
        </span>
    );
}
